import { buttonClasses, EmptyState } from "@scaffquote/ui";
import { MapPin } from "lucide-react";
import { Link } from "react-router";

export function NotFound() {
  return (
    <EmptyState icon={<MapPin />} title="Page not found" className="mt-10">
      That address doesn't match a page in scaffquote.
      <div className="mt-4">
        <Link to="/" className={buttonClasses()}>
          Go to Today
        </Link>
      </div>
    </EmptyState>
  );
}
